import { Instance, types } from 'mobx-state-tree';

export const Suburb = types.model('Suburb', {
  stateAbbreviation: types.string,
  name: types.string,
  postalCode: types.string
});
export type Suburb = Instance<typeof Suburb>;
